module.exports = __webpack_public_path__ + "static/media/wellness_logo.0461ab42.png";